import AreaService from '../../services/models/AreaService';
import ProviderService from '../../services/models/ProviderService';
import TokenService from '../../services/models/TokenService';
import IntegrationService from '../../services/models/IntegrationService';
import {
        CREATE_PROVIDER,
        GET_AREAS,
        GET_DASHDATA,
        SET_DASHDATA,
        SET_AREAS,
        SET_KM,
        SET_PROVIDER,
        UPDATE_PROVIDER,
        SET_COUPON,
        SET_APIKEY,
        GET_APIKEY,
        CREATE_APIKEY,
        CREATE_INTEGRATION,
        SYNC_INTEGRATION,
        GET_INTEGRATIONS,
        SET_INTEGRATIONS,
        UPDATE_INTEGRATION,
        DELETE_INTEGRATION,
        
} from '../mutations';

const areaService = AreaService.build();
const providerService = ProviderService.build();
const tokenService = TokenService.build();
const integrationService = IntegrationService.build();

export default {

    namespaced: true,

    state: {

        areas: null,
        provider: {},
        kmz: null,
        dashData: [],
        coupon: null,
        APIkey: '',
        integrations: []

    },

    getters: {

        areas: state => state.areas,
        provider: state => state.provider,
        kmz: state => state.kmz,
        dashData: state => state.dashData,
        coupon: state => state.coupon,
        APIkey: state => state.APIkey,
        integrations: state => state.integrations,

    },

    mutations: {

        [SET_AREAS]: (state, areas) => {
            state.areas = areas;

        },
        [SET_PROVIDER]: (state, provider) => {
            state.provider = provider;

        },

        [SET_KM]: (state, provider) => {
            state.provider = provider;

        },

        [SET_DASHDATA]: (state, dashData) => {
            state.dashData = dashData;

        },

        [SET_COUPON]: (state, coupon) => {
            state.coupon = coupon;

        },
        [SET_APIKEY]: (state, apikey) => {
            state.APIkey = apikey;

        },
        [SET_INTEGRATIONS]: (state, integrations) => {
            state.integrations = integrations;

        },

    },

    actions: {

        [GET_AREAS]: async ({ commit }) => {

            const areas = await areaService.getAreasById();

            return commit(SET_AREAS, areas);
        },

        [UPDATE_PROVIDER]: async (context, updateData) => {

            const form = new FormData()

            if (updateData.logo) {
                form.append('file', updateData.logo)
                delete updateData.logo
            }

            form.append('form', JSON.stringify(updateData))

            try {

                return await providerService.update(form);

            } catch (error) {

                console.log(error)

                throw error

            }

        },

        [CREATE_PROVIDER]: async ({ commit }, providerData) => {

            providerData.cnpj = providerData.cnpj ? providerData.cnpj.match(/\d+/g).join('') : null
            providerData.phone = providerData.phone ? providerData.phone.match(/\d+/g).join('') : null
            providerData.whatsapp = providerData.whatsapp ? providerData.whatsapp.match(/\d+/g).join('') : null

            const form = new FormData()

            if (providerData.logo) {
                form.append('file', providerData.logo)
                delete providerData.logo
            }

            form.append('form', JSON.stringify(providerData))

            try {

                const create = await providerService.create(form);

                commit(SET_PROVIDER, create);

                return create

            } catch (error) {

                console.log(error)

                throw error

            }

        },

        [GET_DASHDATA]: async ({ commit }, dashData) => {

            const response = await providerService.getDashData(dashData);

            commit(SET_DASHDATA, response);

            return response
        },

        [GET_APIKEY]: async ({ commit }) => {

            const response = await tokenService.getAPIkey();

            commit(SET_APIKEY, response?.rows[0]?.token || "");

            return response
        },

        [CREATE_APIKEY]: async ({ commit }, type) => {

            const response = await tokenService.createAPIkey(type);

            commit(SET_APIKEY, response.token);

            return response
        },

        [CREATE_INTEGRATION]: async (context, integrationData) => {

            const response = await integrationService.createIntegration(integrationData);

            return response
        },

        [UPDATE_INTEGRATION]: async (context, integrationData) => {

            const response = await integrationService.update(integrationData.integration, integrationData.id);

            return response
        },

        [DELETE_INTEGRATION]: async (context, integrationData) => {

            const response = await integrationService.deleteIntegration(integrationData.id);

            return response
        },

        [GET_INTEGRATIONS]: async ({ commit }) => {

            const response = await integrationService.getIntegrations();

            if (!response?.rows.length) return commit(SET_INTEGRATIONS, []);

            commit(SET_INTEGRATIONS, response.rows);

            return response
        },

        [SYNC_INTEGRATION]: async (context, integrationsToSync) => {

            const response = await integrationService.syncIntegration(integrationsToSync);

            return response
        },

    }
}